'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spinner = require('./Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingScreenModal = function LoadingScreenModal(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { className: 'loading-screen-modal' },
    _react2.default.createElement(
      'p',
      null,
      children
    ),
    _react2.default.createElement(_Spinner2.default, { message: 'Verifying', loading: true })
  );
};

LoadingScreenModal.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
};

exports.default = LoadingScreenModal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/LoadingScreenModal.js
// module id = 1199
// module chunks = 0